import { takeLatest, put, call } from 'redux-saga/effects';

import { listPragaDoenca } from '../service';
import {
  NEW_FILTER_PRAGA_DOENCA,
  NEW_FILTER_PRAGA_DOENCA_PENDING,
  NEW_FILTER_PRAGA_DOENCA_SUCCESS,
  NEW_FILTER_PRAGA_DOENCA_FAILURE,
} from '../actionTypes';
import { CONST_FILTER_PRAGA_DOENCA, CONST_ROWS_PER_PAGE } from '@commons/consts';

function* sagaNewFilterPragaDoenca(action) {
  yield put({ type: NEW_FILTER_PRAGA_DOENCA_PENDING });

  try {
    let filterSaved = sessionStorage.getItem(CONST_FILTER_PRAGA_DOENCA) !== null
      ? JSON.parse(sessionStorage.getItem(CONST_FILTER_PRAGA_DOENCA))
      : null;

    let newFilter = {
      nome: '',
      tipo: null,
      cultura: null,
      rows: filterSaved?.rows || CONST_ROWS_PER_PAGE,
      page: filterSaved?.page || 0,
      where: ''
    };

    if (filterSaved === null || filterSaved === undefined) {
      // Primeira vez - sem filtros
      newFilter = {
        ...newFilter,
        where: ''
      };
    } else {
      // Aplicar novo filtro
      if (action.newFilter) {
        // Quando aplica um novo filtro, volta para a primeira página
        newFilter.page = 0;

        let where = '';

        if (action.args.nome !== null && action.args.nome !== undefined && action.args.nome !== '') {
          where = where + '&nome=' + encodeURIComponent(action.args.nome);
        }

        if (action.args.tipo !== null && action.args.tipo !== undefined) {
          where = where + '&tipo=' + action.args.tipo;
        }

        if (action.args.cultura !== null && action.args.cultura !== undefined) {
          where = where + '&cultura=' + action.args.cultura.id;
        }

        newFilter = {
          ...newFilter,
          ...action.args,
          where: where
        };
      } else {
        // Buscar filtro salvo
        let where = '';

        if (filterSaved.nome !== null && filterSaved.nome !== undefined && filterSaved.nome !== '') {
          where = where + '&nome=' + encodeURIComponent(filterSaved.nome);
        }

        if (filterSaved.tipo !== null && filterSaved.tipo !== undefined) {
          where = where + '&tipo=' + filterSaved.tipo;
        }

        if (filterSaved.cultura !== null && filterSaved.cultura !== undefined) {
          where = where + '&cultura=' + filterSaved.cultura.id;
        }

        newFilter = {
          ...filterSaved,
          where: where
        };
      }
    }

    // Buscar registros
    const queryString = `?size=${newFilter.rows}&page=${newFilter.page}${newFilter.where}`;
    const list = yield call(listPragaDoenca, queryString);

    sessionStorage.setItem(CONST_FILTER_PRAGA_DOENCA, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_PRAGA_DOENCA_SUCCESS,
      list: list,
      filter: newFilter
    });
  } catch (error) {
    yield put({ type: NEW_FILTER_PRAGA_DOENCA_FAILURE });
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchNewFilterPragaDoenca() {
  yield takeLatest(NEW_FILTER_PRAGA_DOENCA, sagaNewFilterPragaDoenca);
}